import React, { useState } from 'react';
import { CONTACT_INFO } from '../constants/config';

const FAQ = () => {
  const [expandedItems, setExpandedItems] = useState(new Set());

  const toggleItem = (id) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedItems(newExpanded);
  };

  const faqData = [
    {
      id: 1,
      question: "How far in advance should I book my tour?",
      answer: "We recommend booking at least 2-3 weeks in advance, especially during peak seasons (spring and summer). For popular tours like our Wine Country Adventure, booking a month ahead ensures availability."
    },
    {
      id: 2,
      question: "What happens if the weather is bad on my tour day?",
      answer: "Our tours operate rain or shine! All our buses are climate-controlled and comfortable in any weather. For outdoor activities, we provide covered areas and have backup indoor options. Tours are only cancelled in extreme weather conditions for safety reasons."
    },
    {
      id: 3,
      question: "Are your tours wheelchair accessible?",
      answer: "Yes, we have wheelchair-accessible buses available. Please notify us when booking so we can ensure the appropriate vehicle is assigned to your tour. Our drivers are trained to assist passengers with mobility needs."
    },
    {
      id: 4,
      question: "What's included in the tour price?",
      answer: "All tours include transportation in our luxury buses, professional tour guide service, and any entrance fees mentioned in the tour description. Meals and personal expenses are typically not included unless specifically stated."
    },
    {
      id: 5,
      question: "Can I bring food and drinks on the bus?",
      answer: "Non-alcoholic beverages are welcome on all tours. Light snacks are permitted. Alcohol is only allowed on designated wine tours where it's part of the experience. Please keep the bus clean and dispose of trash properly."
    },
    {
      id: 6,
      question: "What's your cancellation policy?",
      answer: "Cancellations made 7+ days before the tour date receive a full refund. Cancellations 3-6 days prior receive a 50% refund. Cancellations within 48 hours are non-refundable unless due to medical emergencies with documentation."
    },
    {
      id: 7,
      question: "Do you offer private tours or group discounts?",
      answer: "Yes! We offer private charter services for groups of 15+ passengers. Group discounts start at 10% for 8+ people. Corporate packages and multi-day tours are also available. Contact us for custom pricing."
    },
    {
      id: 8,
      question: "What should I bring on the tour?",
      answer: "Bring comfortable walking shoes, weather-appropriate clothing, a camera, and any personal medications. We recommend sunglasses and a hat for outdoor portions. Umbrellas are provided if needed."
    },
    {
      id: 9,
      question: "Are children allowed on tours?",
      answer: "Children are welcome on most tours! Kids under 3 ride free when sitting on a parent's lap. Children 3-12 receive a 20% discount. Car seats are required for children under 8 - please bring your own or notify us to arrange one."
    },
    {
      id: 10,
      question: "How do I know if my tour requires a minimum number of passengers?",
      answer: "Tours with minimum passenger requirements are clearly marked on our Tours page and during booking. If minimum numbers aren't met, we'll contact you 48 hours before the tour to offer alternative dates or a full refund."
    },
    {
      id: 11,
      question: "Can I modify my booking after it's confirmed?",
      answer: "Yes, modifications can be made up to 3 days before your tour date, subject to availability. Changes may incur additional fees. Contact our customer service team to discuss your needs."
    },
    {
      id: 12,
      question: "Do you provide pickup and drop-off services?",
      answer: "We offer pickup from designated central locations in the city. Door-to-door service is available for private tours and groups of 10+ for an additional fee. All pickup locations and times are provided in your confirmation email."
    }
  ];

  return (
    <div className="faq">
      <div className="container">
        <h1>Frequently Asked Questions</h1>
        <p className="faq-intro">
          Find answers to common questions about our tour services. Can't find what you're looking for? 
          <a href="/contact"> Contact us directly</a> for personalized assistance.
        </p>
        
        <div className="faq-list">
          {faqData.map(item => (
            <div key={item.id} className="faq-item">
              <button 
                className={`faq-question ${expandedItems.has(item.id) ? 'expanded' : ''}`}
                onClick={() => toggleItem(item.id)}
                aria-expanded={expandedItems.has(item.id)}
              >
                {item.question}
                <span className="faq-icon">{expandedItems.has(item.id) ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${expandedItems.has(item.id) ? 'expanded' : ''}`}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="faq-contact">
          <h2>Still Have Questions?</h2>
          <p>Our customer service team is here to help! Contact us for personalized assistance.</p>
          <div className="faq-contact-buttons">
            <a href="/contact" className="btn btn-primary">Contact Us</a>
            <a href={`tel:${CONTACT_INFO.primaryPhone}`} className="btn btn-secondary">Call {CONTACT_INFO.primaryPhone}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;